var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .debit-1 {\n        fill: #fff;\n      }\n      .debit-2 {\n        fill: #f1f1f1;\n      }\n      .debit-3 {\n        mask: url(#mask);\n      }\n      .debit-4 {\n        fill: #e34940;\n      }\n      .debit-5 {\n        fill: #2d3f4f;\n      }\n      .debit-6 {\n        fill: #ecf0f1;\n      }\n      .debit-7 {\n        mask: url(#mask-2-2);\n      }\n      .debit-8 {\n        fill: #bd362f;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 89,
    height: 89,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    className: "debit-1",
    cx: 44.5,
    cy: 44.5,
    r: 44.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 43.08,
    y: 45.11,
    width: 21.18,
    height: 12.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    className: "debit-1",
    x: 43.08,
    y: 45.11,
    width: 21.18,
    height: 12.61,
    rx: 2.5
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Debit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-_-Debit",
    "data-name": "Illustration-/-Debit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4FE1\\u7528\\u5361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1-2",
    "data-name": "path-1",
    className: "debit-2",
    cx: 44.5,
    cy: 44.5,
    r: 44.5
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "debit-4",
    d: "M63,18H8.75a44.49,44.49,0,0,0,3.71,57.37H63a5,5,0,0,0,5-5V23A5,5,0,0,0,63,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "debit-5",
    d: "M.38,38.8H68V27.46H3.39A43.9,43.9,0,0,0,.38,38.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "debit-6",
    d: "M2,57.72H38.1V45.11H0A44.16,44.16,0,0,0,2,57.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u6807\\u5FD7\\u533A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-3-2",
    "data-name": "path-3",
    className: "debit-1",
    x: 43.08,
    y: 45.11,
    width: 21.18,
    height: 12.61,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "debit-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9634\\u5F71",
    className: "debit-6",
    d: "M43.08,47.61V57.72L64.26,45.11H45.58A2.5,2.5,0,0,0,43.08,47.61Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u5361\\u53F7\\u533A",
    className: "debit-8",
    x: 24.39,
    y: 67.17,
    width: 39.87,
    height: 5.04,
    rx: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.4729272d345f288f8101ed16145675c4.svg";
export { ForwardRef as ReactComponent };